import { advanceQuoteDaysStates } from '@ourbranch/lookups';

/*
 * FED vs AQD — Business Rules
 *
 * Each state is either an FED state or an AQD state, never both.
 *
 * FED (Future Effective Discount)
 *   - Applies to: Home and Auto
 *   - Discount is based on the days between the rate control date (always forced to
 *     today on an offer) and the policy effective date, regardless of when the offer
 *     lineage was first created.
 *   - Footer behavior when offer is out of date:
 *       • Encourage the user to push effective date(s) to at least 8 days from today
 *         to maximise the FED discount.
 *       • If all effective dates are already 8+ days out, show a plain
 *         "let's update this offer" message instead.
 *
 * AQD (Advance Quote Discount)
 *   - Applies to: Auto ONLY (even in states that are "AQD states", home/condo/renters
 *     policies are not eligible — but FED messaging is still suppressed for all policy
 *     types in an AQD state).
 *   - Discount is based on the days between when the offer lineage was first created
 *     and the policy effective date, regardless of the rate control date.
 *   - Footer behavior when offer is out of date:
 *       • Show the standard Update Offer footer (no effective-date nudge needed).
 *
 * Shared rule (all states)
 *   - If the offer is out of date AND any policy's effective date is in the past,
 *     the user must manually update the effective date before continuing.
 *     This takes priority over both the FED and AQD footers.
 *
 * TLDR footer rules:
 * Rule 1 - FED + out-of-date, future date → isOutOfDateOffer && !stateIsInAQD → FEDOfferFooter
 * Rule 2 - AQD + out-of-date, future date → isOutOfDateOffer → UpdateOffer
 * Rule 3 - any state + out-of-date + past date → shouldShowPastEffectiveDateFooter → AQDOfferFooter
 * Rule 4 - AQD non-stale + past date → shouldShowAQDFooter → AQDOfferFooter
 */

export const offerUsesAdvanceQuoteDays = (state, policyType) => {
  if (!state || !policyType) {
    return false;
  }

  const adqState = advanceQuoteDaysStates[state];
  if (!adqState) {
    return false;
  }

  const policyTypes = policyType.split('');
  return policyTypes.some((type) => adqState[type] === true);
};

// Returns true if the state is in the AQD lookup at all, regardless of policy type.
// Used to suppress FED messaging/discount for all policy types in AQD states.
export const stateHasAdvanceQuoteDays = (state) => {
  return !!advanceQuoteDaysStates[state];
};
